import {Box} from 'platform/foundation';

const SWATCH_STEPS = 2;
const SWATCH_VIEWBOX = 8;
const SWATCH_CORNER_RADIUS = 2;

interface ChartSwatchProps {
  /** Series color, as Recharts passes it to the tooltip and the legend. */
  color: string | undefined;
}

/**
 * Color key of one series, next to its name in the tooltip or the legend.
 *
 * Drawn as SVG because the color is a resolved color value, and `Box` takes only design
 * tokens for its background. The wrapping `Box` keeps the label from squeezing the swatch.
 */
export function ChartSwatch(props: ChartSwatchProps) {
  return (
    <Box width={SWATCH_STEPS} height={SWATCH_STEPS} flexShrink={0}>
      <svg
        aria-hidden
        width="100%"
        height="100%"
        viewBox={`0 0 ${SWATCH_VIEWBOX} ${SWATCH_VIEWBOX}`}
      >
        <rect
          width={SWATCH_VIEWBOX}
          height={SWATCH_VIEWBOX}
          rx={SWATCH_CORNER_RADIUS}
          fill={props.color}
        />
      </svg>
    </Box>
  );
}
